import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import { useParams } from "@tanstack/react-router";
import type * as fhirTypes from "fhir/r4";

export interface FollowUpResponse {
  carePlan: fhirTypes.CarePlan;
  followupDurationUnit: string | null;
  followupDurationValue: number | null;
  followupMessage: string | null;
  carePlanOutreachEnabled?: boolean;
}

export const useFollowUp = ({
  encounterId,
  carePlanId,
  enabled,
}: { encounterId: string; carePlanId: string; enabled: boolean }) => {
  const { patientId } = useParams({ from: "/patient/$patientId" });
  return useApi<FollowUpResponse>({
    queryOptions: {
      enabled,
      queryFn: async () => {
        const response = await axiosInstance.get<FollowUpResponse>(
          `/charting/careplan/${carePlanId}/followup`,
        );

        return response.data;
      },
      queryKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.FollowUp.DEFAULT({
          patientId,
          childEncounterId: encounterId,
          carePlanId,
        }),
    },
  });
};
